import React, { useState, useEffect } from 'react'

import { DotsCircleLoader } from '@reactiveonline/frontend_shared_components'
import RentalListItems from '../../rentals/RentalListItems'

export default function RentalList({ item, deviceType, extraData }) {
  const { settings } = item
  const {
    id, classes, viewType, itemsPerRow, itemsLimit, selectionCriterion, items
  } = settings
  const appProps = extraData

  const [entities, setEntities] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect( () => {
    fetchEntities()
  }, [])

  async function fetchEntities() {
    if (selectionCriterion !== 'custom' || items.length) {
      let params = `rental_limit=${ itemsLimit }&selected_rental_items=${ selectionCriterion }`

      if (selectionCriterion === 'custom') {
        params += `&items=${ JSON.stringify(items) }`
      }

      setLoading(true)

      Rails.ajax({
        type: 'GET',
        url: `${ appProps.selectedRentalsPath }?${ params }`,
        dataType: 'json',
        success: result => {
          if (result.items) {
            let fetchedItems = result.items

            if (selectionCriterion === 'custom') {
              fetchedItems = []
              items.forEach( item => {
                const fetchedItem = result.items.find( fetchedItem => fetchedItem.uid === item.uid )
                if (fetchedItem) {
                  fetchedItems.push(fetchedItem)
                }
              })
            }

            setEntities(fetchedItems)
          }
        },
        complete: result => {
          setLoading(false)
        }
      })
    }
  }

  function getViewType() {
    switch (viewType) {
      case 'classic':
        return 'version_one'
      case 'minimalistic':
        return 'version_two'
      case 'luxury':
        return 'version_three'
      case 'list':
        return 'version_four'
    }
  }

  function getItemsPerRow() {
    switch (String(itemsPerRow)) {
      case '1':
        return 'one_item'
      case '2':
        return 'two_items'
      case '3':
        return 'three_items'
      case '4':
        return 'four_items'
      case '5':
        return 'five_items'
      case '6':
        return 'six_items'
    }
  }

  return (
    <div
      id={ id || item.id }
      className={ `rb-rental-list ${ classes || '' }` }
    >
      <RentalListItems
        appProps={ appProps }
        rentals={ entities }
        rentalListVersion={ getViewType() }
        itemsPerRowClass={ getItemsPerRow() }
        itemsPerRow={ itemsPerRow }
        parentId={ id || item.id }
        loading={ loading }
      />

      { loading &&
        <div className='flex-box items-center content-center flex-1'>
          <DotsCircleLoader/>
        </div>
      }
    </div>
  )
}
